<i18n>
{
  "fr": {
    "title": "Pièces jointes",
    "photos": "Photos",
    "schema": "Schémas",
    "technicalFiles": "Documents techniques",
    "report": "Comptes rendus",
    "conventions": "Conventions",
    "other": "Autres",
    "download": "Télécharger",
    "fileName": "Nom du fichier",
    "fileSize": "Taille"
    }
}
</i18n>
<template>
  <b-row class="files-data">
    <b-col md="12" v-if="attachment != null">
      <h4 class="header-title">{{ $t('title') }}</h4>
      <h4>{{ $t('photos') }}</h4>
      <hr>
      <div class="account-error-div" v-if="attachment.photos &&  Object.keys(attachment.photos).length > 0">
        <table class="table admin-list">
            <thead>
              <tr>
                <th>{{ $t('fileName') }}</th>
                <th>{{ $t('fileSize') }}</th>
                <th></th>
              </tr>
            </thead>
          <tbody>
            <tr v-for="file in attachment.photos" :key="file.id" class="request_row">
              <td>
                <v-icon name="file"/>
                {{ file.originalFileName }}
              </td>
              <td>{{ formatBytes(file.size) }}</td>
              <td>
                <a :href="getLink(file.id)" target="_blank">{{ $t('download') }}</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h4>{{ $t('schema') }}</h4>
      <hr>
      <div class="account-error-div" v-if="attachment.schemas &&  Object.keys(attachment.schemas).length > 0">
        <table class="table admin-list">
            <thead>
              <tr>
                <th>{{ $t('fileName') }}</th>
                <th>{{ $t('fileSize') }}</th>
                <th></th>
              </tr>
            </thead>
          <tbody>
            <tr v-for="file in attachment.schemas" :key="file.id" class="request_row">
              <td>
                <v-icon name="file"/>
                {{ file.originalFileName }}
              </td>
              <td>{{ formatBytes(file.size) }}</td>
              <td>
                <a :href="getLink(file.id)" target="_blank">{{ $t('download') }}</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h4>{{ $t('technicalFiles') }}</h4>
      <hr>
      <div class="account-error-div" v-if="attachment.technicalFiles &&  Object.keys(attachment.technicalFiles).length > 0">
        <table class="table admin-list">
            <thead>
              <tr>
                <th>{{ $t('fileName') }}</th>
                <th>{{ $t('fileSize') }}</th>
                <th></th>
              </tr>
            </thead>
          <tbody>
            <tr v-for="file in attachment.technicalFiles" :key="file.id" class="request_row">
              <td>
                <v-icon name="file"/>
                {{ file.originalFileName }}
              </td>
              <td>{{ formatBytes(file.size) }}</td>
              <td>
                <a :href="getLink(file.id)" target="_blank">{{ $t('download') }}</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h4>{{ $t('report') }}</h4>
      <hr>
      <div class="account-error-div" v-if="attachment.reports &&  Object.keys(attachment.reports).length > 0">
        <table class="table admin-list">
            <thead>
              <tr>
                <th>{{ $t('fileName') }}</th>
                <th>{{ $t('fileSize') }}</th>
                <th></th>
              </tr>
            </thead>
          <tbody>
            <tr v-for="file in attachment.reports" :key="file.id" class="request_row">
              <td>
                <v-icon name="file"/>
                {{ file.originalFileName }}
              </td>
              <td>{{ formatBytes(file.size) }}</td>
              <td>
                <a :href="getLink(file.id)" target="_blank">{{ $t('download') }}</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h4>{{ $t('conventions') }}</h4>
      <hr>
      <div class="account-error-div" v-if="attachment.conventions &&  Object.keys(attachment.conventions).length > 0">
        <table class="table admin-list">
            <thead>
              <tr>
                <th>{{ $t('fileName') }}</th>
                <th>{{ $t('fileSize') }}</th>
                <th></th>
              </tr>
            </thead>
          <tbody>
            <tr v-for="file in attachment.conventions" :key="file.id" class="request_row">
              <td>
                <v-icon name="file"/>
                {{ file.originalFileName }}
              </td>
              <td>{{ formatBytes(file.size) }}</td>
              <td>
                <a :href="getLink(file.id)" target="_blank">{{ $t('download') }}</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>      
      <h4>{{ $t('other') }}</h4>
      <hr>
      <div class="account-error-div" v-if="attachment.others &&  Object.keys(attachment.others).length > 0">
        <table class="table admin-list">
            <thead>
              <tr>
                <th>{{ $t('fileName') }}</th>
                <th>{{ $t('fileSize') }}</th>
                <th></th>
              </tr>
            </thead>
          <tbody>
            <tr v-for="file in attachment.others" :key="file.id" class="request_row">
              <td>
                <v-icon name="file"/>
                {{ file.originalFileName }}
              </td>
              <td>{{ formatBytes(file.size) }}</td>
              <td>
                <a :href="getLink(file.id)" target="_blank">{{ $t('download') }}</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'FileData',
  props: {
    attachment: { 
      required: true,
      default: null,
    },
  },
  computed: {
    ...mapState({ property: state => state.refProperties.property }),
  },
  methods: {
    getLink(fileId) {
      return this.$store.getters.getFileProperty({ fileId: fileId });
    },
    formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
  },
};
</script>

<style scoped>
.table th:nth-last-child(-n+2) {
  width: 100px;
}
</style>

